import React, { useState, useEffect, useContext } from "react";
import formatSchedule from "../Global/formatSchedule";
import capitalizeFirstLetter from "../Global/capitalizeFirstLetter";
import addQueryParams from "./../Global/addQueryParams";
import getIfOpen from "../Global/getIfOpen";
import { GlobalContext } from "./../Context";

const Result = ({
  name,
  location,
  id,
  date,
  dateCounter,
  services,
  coordinates,
  image,
  deactivateSchedule,
  deactivatePhone,
  aditionalInfo,
  mobilePhone,
  principalPhone,
  type,
  entityId,
  geographyLocation,
  fieldLocation,
  setCardListState,
  hasElectricCharger,
  isBranchSchedules = false,
}) => {
  const globalContext = useContext(GlobalContext);
  const {
    setCurrentPopUp,
    currentBranch,
    setCurrentBranch,
    setisShareButtonClicked,
    setBackButtonType,
    setBackButtonVisibility,
    setBranchSchedulesVisibility,
    setFiltersVisibility,
    setResultsState,
    setCategorySelected,
    setCategoryFilters,
    setAdvancedFiltersVisibility,
    setMarkersVisibility
  } = globalContext;
  const [scheduleState, setScheduleState] = useState(null);
  const [scheduleCounterState, setScheduleCounterState] = useState(null);
  const [scheduleGeneralState, setscheduleGeneralState] = useState(null);
  let availableType = "";
  const [formatedDate, setFormatedDate] = useState(null);
  const [formatedCounterDate, setFormatedCounterDate] = useState(null);
  if (type && typeof type === "string") {
    availableType = type;
  } else if (type) {
    availableType = type.entity.entityLabel;
  } else {
    availableType = null;
  }

  const branchOfficeStateClass = () => {
    let currentClass = "card-teaser__state";
    if (scheduleGeneralState === "Abierto") {
      currentClass += " card-teaser__state--open";
    } else {
      currentClass += " card-teaser__state--close";
    }
    return currentClass;
  };

  useEffect(() => {
    const totalDates = formatSchedule(date);
    setFormatedDate(totalDates);
  }, [date]);

  useEffect(() => {
    const totalDates = formatSchedule(dateCounter);
    setFormatedCounterDate(totalDates);
  }, [dateCounter]);

  useEffect(() => {
    if (formatedDate) {
      const updateScheduleState = (state) => {
        setScheduleState(state);
      };
      getIfOpen(
        formatedDate.currentDate,
        updateScheduleState,
        formatedDate.otherDaysOpen
      );
    }
  }, [formatedDate]);

  useEffect(() => {
    if (formatedCounterDate) {
      const updateScheduleCounterState = (state) => {
        setScheduleCounterState(state);
      };
      getIfOpen(
        formatedCounterDate.currentDate,
        updateScheduleCounterState,
        formatedCounterDate.otherDaysOpen
      );
    }
  }, [formatedCounterDate]);

  useEffect(() => {
    if (scheduleState && scheduleCounterState) {
      if (scheduleState === "Abierto" || scheduleCounterState === "Abierto") {
        setscheduleGeneralState("Abierto");
      } else if (
        scheduleState === "NotFound" &&
        scheduleCounterState === "NotFound"
      ) {
        setscheduleGeneralState("NotFound");
      } else {
        setscheduleGeneralState("Cerrado");
      }
    }
  }, [scheduleState, scheduleCounterState]);

  return (
    <div
      className={`card-teaser ${
        currentBranch === id ? "card-teaser--open" : ""
      }`}
      onClick={() => {
        setCurrentPopUp({
          entityLabel: name,
          fieldOfficeBranchType: availableType,
          fieldAddress: location,
          fieldSchedule: formatedDate,
          fieldScheduleCounter: formatedCounterDate,
          queryFieldServices: {
            entities: services,
          },
          fieldCoordinates: coordinates,
          image: image,
          deactivateSchedule: deactivateSchedule,
          aditionalInfo: aditionalInfo,
          deactivatePhone: deactivatePhone,
          mobilePhone: mobilePhone,
          principalPhone: principalPhone,
          branchScheduleState: scheduleGeneralState,
          entityId,
          geographyLocation,
          fieldLocation,
          hasElectricCharger,
        });
        setBackButtonType("result");
        setBackButtonVisibility(true);
        setCurrentBranch(id);
        setisShareButtonClicked(false);
        setCardListState("close");
        setBranchSchedulesVisibility(false);
        setResultsState(true);
        setFiltersVisibility(false);
        setMarkersVisibility(true);
        setCategoryFilters(null);
        setCategorySelected(null);
        setAdvancedFiltersVisibility(false);
        addQueryParams({
          "nombre-sucursal": name,
          "id-sucursal": entityId,
        });
      }}
      onKeyDown={(event) => {
        if (event.keycode === 13) setCurrentPopUp(true);
      }}
      role="button"
      tabIndex={0}
    >
      <div
        className={`card-teaser__heading ${
          isBranchSchedules ? "card-teaser__heading--branch-schedule" : ""
        }`}
      >
        {isBranchSchedules && scheduleGeneralState !== "NotFound" && (
          <span
            className={
              deactivateSchedule
                ? "card-teaser__state card-teaser__state--open"
                : branchOfficeStateClass()
            }
          >
            {deactivateSchedule ? "Abierto" : scheduleGeneralState}
          </span>
        )}
        {name && <h3 className="card__name">{name}</h3>}
        {!isBranchSchedules && scheduleGeneralState !== "NotFound" && (
          <span
            className={
              deactivateSchedule
                ? "card-teaser__state card-teaser__state--open"
                : branchOfficeStateClass()
            }
          >
            {deactivateSchedule ? "Abierto" : scheduleGeneralState}
          </span>
        )}
      </div>
      {hasElectricCharger === true && (
        <p className="card__electric-charger">
          Sucursal con estación de carga para vehículos eléctricos
        </p>
      )}
      {!isBranchSchedules && location && (
        <p className="card__location">{capitalizeFirstLetter(location)}</p>
      )}
      {formatedDate &&
        formatedDate.finalDates &&
        formatedDate.finalDates.length > 0 &&
        !deactivateSchedule && (
          <>
            {formatedCounterDate &&
              formatedCounterDate.finalDates &&
              formatedCounterDate.finalDates.length > 0 && (
                <h3 className="card-locations__schedule-label">
                  Horario para cajas:{" "}
                </h3>
              )}
            <div className="card-locations-popup__dates">
              <div>
                {formatedDate.finalDates.map((date, index) => (
                  <p className="card-locations-popup__date" key={index}>
                    {date}
                  </p>
                ))}
              </div>
            </div>
          </>
        )}
      {formatedCounterDate &&
        formatedCounterDate.finalDates &&
        formatedCounterDate.finalDates.length > 0 &&
        !deactivateSchedule && (
          <>
            {formatedDate &&
              formatedDate.finalDates &&
              formatedDate.finalDates.length > 0 && (
                <h3 className="card-locations__schedule-label">
                  Horario para mostrador:{" "}
                </h3>
              )}
            <div className="card-locations-popup__dates">
              <div>
                {formatedCounterDate.finalDates.map((date, index) => (
                  <p className="card-locations-popup__date" key={index}>
                    {date}
                  </p>
                ))}
              </div>
            </div>
          </>
        )}
    </div>
  );
};

export default Result;
